var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGarland = function SvgGarland(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 2 Q 80 12 160 2",
    stroke: "#BACCDD",
    strokeWidth: 1,
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12,3 22,12 32,5",
    fill: "#7BA4D9",
    opacity: 0.85
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "34,5 44,14 54,7",
    fill: "#F8B179",
    opacity: 0.85
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "56,7 66,15 76,9",
    fill: "#FDE28A",
    opacity: 0.85
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "78,9 88,16 98,9",
    fill: "#68C6B9",
    opacity: 0.85
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "100,9 110,15 120,7",
    fill: "#F8A5A5",
    opacity: 0.85
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "122,7 132,14 142,5",
    fill: "#7BA4D9",
    opacity: 0.85
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "144,5 154,12 164,3",
    fill: "#FDE28A",
    opacity: 0.85
  })));
};
export default SvgGarland;